export const LOADING = 'flowLoading';
export const ERROR = 'flowError';
export const GET = 'flowGet';
export const ADD = 'flowAdd';
export const UPDATE = 'flowUpdate';
export const DELETE = 'flowDelete';
export const TRIGGER = 'flowTrigger';
